import styled from 'styled-components';
import svgItem from '../../assets/onboarding/confirmation.svg';

const Confirmation = styled(svgItem as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '4.4rem'};
  height: ${props => props.height || '4.4rem'};
  fill: ${props => props.fill || props.theme.colors.black.base};
`;

export default Confirmation;
